import React from 'react';
import { Footer } from './Footer';

interface PublicLayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

/**
 * Layout wrapper for public pages (landing, legal pages, etc.)
 * Includes footer navigation
 */
export function PublicLayout({ children, showFooter = true }: PublicLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">
        {children}
      </div>
      {showFooter && <Footer />}
    </div>
  );
}
